import { Center, Loader, Paper, Table, Text, Title, createStyles } from "@mantine/core"
import { formatDateTime } from "@medplum/core";
import { StatusBadge, useMedplum } from "@medplum/react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";


const useStyles = createStyles((theme) => ({
  table: {
    marginTop: "30px"
  },
  thead: {
    backgroundColor: '#BEDEF8',
    borderRadius: 4,
  },
}));

export const Immunization = () => {
  const { patientId } = useParams()
  const { classes } = useStyles();
  const medplum = useMedplum();
  const [immunizations, setImmunizations] = useState<any>([]);
  const [isFetching, setIsFetching] = useState<boolean>(true);
  const tableHeaders = ["Immunization Name", "Date Administered", "Status"]

  useEffect(() => {
    getImmunization()
  }, [patientId])

  const getImmunization = async () => {
    const res = await medplum.searchResources('Immunization', `patient=Patient/${patientId}`)
    setIsFetching(false)
    setImmunizations(res)
  }

  return (
    <>
      <Paper
        sx={{
          marginTop: "20px",
          borderRadius: "8px",
          marginLeft: "0px",
          marginRight: "0px",
          padding: "20px",
          background: "'#FFF",
          boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
        }}
        withBorder
      >
        <Title>
          Immunization
        </Title>
        <Table className={classes.table}>
          <thead className={classes.thead}>
            <tr>
              {
                tableHeaders.map((val) => {
                  return (
                    <th key={val}>
                      {val}
                    </th>
                  )
                })
              }
            </tr>
          </thead>
          {
            <tbody>
              {
                immunizations.map((vaccine: any) => (
                  <tr key={vaccine.id}>
                    <td>{vaccine.vaccineCode?.text}</td>
                    <td>{formatDateTime(vaccine.occurrenceDateTime)}</td>
                    <td><StatusBadge status={vaccine.status as string} /></td>
                  </tr>
                ))
              }
            </tbody>
          }
        </Table>
        {(immunizations?.length === 0 && !isFetching) && (
          <Center style={{ width: "100%", height: "200px" }}>
            <Text size="xl" color="dimmed">
              No results
            </Text>
          </Center>
        )}
        {
          isFetching &&
          <Center style={{ width: "100%", height: "200px" }}>
            <Loader />
          </Center>
        }
      </Paper>
    </>
  )
}